import { Component, OnInit, NgModule, Input, ViewChild } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { CommonModule } from "@angular/common";
import { DxDrawerModule, DxDrawerTypes } from "devextreme-angular/ui/drawer";
import {
  DxScrollViewModule,
  DxScrollViewComponent,
} from "devextreme-angular/ui/scroll-view";
import { DxToolbarModule } from "devextreme-angular/ui/toolbar";

import {
  SideNavigationMenuComponent,
  HeaderComponent,
} from "../../shared/components";
import { ScreenService } from "../../shared/services";
import { ThemeService } from "../../shared/services/theme.service";

@Component({
  selector: "app-side-nav-inner-toolbar",
  templateUrl: "./side-nav-inner-toolbar.component.html",
  styleUrls: ["./side-nav-inner-toolbar.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    DxDrawerModule,
    DxScrollViewModule,
    DxToolbarModule,
    SideNavigationMenuComponent,
    HeaderComponent,
  ],
})
export class SideNavInnerToolbarComponent implements OnInit {
  @ViewChild(DxScrollViewComponent, { static: true })
  scrollView!: DxScrollViewComponent;
  selectedRoute = "";

  menuOpened!: boolean;
  temporaryMenuOpened = false;

  @Input()
  title!: string;

  menuMode: DxDrawerTypes.OpenedStateMode = "shrink";
  menuRevealMode: DxDrawerTypes.RevealMode = "expand";
  minMenuSize = 60;
  shaderEnabled = false;
  swatchClassName = "dx-swatch-additional";

  sidebarWidth = 250;

  get isXSmall(): boolean {
    return this.screen.sizes["screen-x-small"];
  }

  constructor(
    protected themeService: ThemeService,
    private screen: ScreenService,
    private router: Router,
  ) {
    themeService.isDark.subscribe((isDark) => {
      this.swatchClassName = "dx-swatch-additional" + (isDark ? "-dark" : "");
    });
  }

  ngOnInit() {
    const isDesktop = this.screen.sizes["screen-large"] || this.screen.sizes["screen-medium"];
    this.menuOpened = isDesktop;

    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.selectedRoute = val.urlAfterRedirects.split("?")[0];
      }
    });

    this.screen.changed.subscribe(() => {
      this.updateDrawer();
    });

    this.updateDrawer();
  }

  updateDrawer() {
    const isXSmall = this.screen.sizes["screen-x-small"];
    const isSmall = this.screen.sizes["screen-small"];
    const isMedium = this.screen.sizes["screen-medium"];
    const isLarge = this.screen.sizes["screen-large"];
    const isDesktop = isLarge || isMedium;

    const prevMode = this.menuMode;
    this.menuMode = isDesktop ? "shrink" : "overlap";
    this.menuRevealMode = isXSmall ? "slide" : "expand";
    this.minMenuSize = isXSmall ? 0 : 60;
    this.shaderEnabled = !isDesktop;
    this.sidebarWidth = isXSmall
      ? Math.min(280, Math.floor((typeof window !== "undefined" ? window.innerWidth : 360) * 0.82))
      : isSmall ? 240 : 250;

    // If transitioned from desktop shrink to mobile overlay, close it
    if (!isDesktop && prevMode === "shrink") {
      this.menuOpened = false;
    }
  }

  toggleMenu = (e?: any) => {
    this.menuOpened = !this.menuOpened;
    e?.event?.stopPropagation?.();
    e?.stopPropagation?.();
  };

  closeSidebarMobile = (e?: Event) => {
    e?.stopPropagation();
    this.menuOpened = false;
  };

  get hideMenuAfterNavigation() {
    return this.menuMode === "overlap" || this.temporaryMenuOpened;
  }

  get showMenuAfterClick() {
    return !this.menuOpened;
  }

  navigationChanged(event: any) {
    if (this.hideMenuAfterNavigation) {
      this.temporaryMenuOpened = false;
      this.menuOpened = false;
    }
    if (this.scrollView?.instance) {
      this.scrollView.instance.scrollTo(0);
    }
  }

  navigationClick() {
    if (this.showMenuAfterClick) {
      this.temporaryMenuOpened = true;
      this.menuOpened = true;
    }
  }
}

@NgModule({
  imports: [SideNavInnerToolbarComponent],
  exports: [SideNavInnerToolbarComponent],
})
export class SideNavInnerToolbarModule { }
